import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDTitleText,
  FDAccordion,
  FDAccordionTitle,
  FDAccordionDetails,
  FDPaper, FDBodyText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const useStyles = buildUseStyles('ClientAccordion', (() => ({
  hyperlink: {
    textDecoration: 'underline',
    color: 'inherit',
  },
})));

const ClientAccordion = ({ expandedID, setExpandedID }) => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const { clearModalCollection } = useModalContext();
  const classes = useStyles();
  const reVerifyIdentity = resource.withRelationship(
    fr.relationships.reVerifyIdentity.name,
    (rel) => (
      <FDBodyText value={
        <>
          <span>{rel.meta('title')}</span>
          &nbsp;
          <a
            href="#"
            className={classes.hyperlink}
            onClick={() => {
              loadPageContentLink(rel.link('related'));
              clearModalCollection();
            }}
          >
            {rel.meta('prompt')}
          </a>
        </>
      }
      />
    ),
    () => null,
  );

  return (
    <FDPaper appearance="elevated">
      <FDAccordion
        expansionID="primary"
        expanded={expandedID === resource.id()}
        onChange={(expanded) => {
          if (!expanded) {
            return; // Don't let anyone manually close one of these
          }
          setExpandedID(resource.id());
        }}
      >
        <FDAccordionTitle>
          <FDTitleText value={resource.attr('fullName')} />
        </FDAccordionTitle>
        <FDAccordionDetails>
          <FDStack direction="column" spacing={3}>
            <FDInputRow>
              <MetaControlField attr="firstName" />
              <MetaControlField attr="lastName" />
              <MetaControlField attr="dateOfBirth" />
              <MetaControlField attr="ssn" />
              <MetaControlField attr="phoneNumber" />
            </FDInputRow>
            <FDStack spacing={1} direction="column">
              <FDTitleText value="Primary address" />
              <FDInputRow>
                <MetaControlField attr="addressLine1" />
                <MetaControlField attr="addressLine2" />
                <MetaControlField attr="city" />
                <MetaControlField attr="state" />
                <MetaControlField attr="zip" />
              </FDInputRow>
            </FDStack>
            <MetaLayoutRemainingFields />
            {reVerifyIdentity}
          </FDStack>
        </FDAccordionDetails>
      </FDAccordion>
    </FDPaper>
  );
};

ClientAccordion.defaultProps = {
  expandedID: undefined,
};
ClientAccordion.propTypes = {
  expandedID: PropTypes.string,
  setExpandedID: PropTypes.func.isRequired,
};

export default ClientAccordion;
